import { RootModel } from '@pc/models';
import { Api, ApiConfig } from '@shared/api';
import { createModel } from '@rematch/core';
import { isEmpty } from 'lodash';
import { GroupType, TableItetmType } from '../set-permissions/interface';
import { getPermissionLabel, getPermissionLevel } from '../set-permissions/utils';
import { UserType } from './interface';

type SetPermissionsAlertState = {
  users: Array<UserType>;
};

const SetPermissionsAlertModel = createModel<RootModel>()({
  name: 'SetPermissionsAlertModel',
  state: {
    users: [],
  } as any as SetPermissionsAlertState,
  reducers: {
    setUsers(state, users: SetPermissionsAlertState['users']) {
      return {
        ...state,
        users,
      };
    },
  },
  effects: (dispatch) => ({
    initData(payload, rootState) {
      const users: { [id: string]: UserType } = {};
      const { tableData, groups = [] } = rootState.SetPermissionsModel;

      groups
        .filter((item) => item.isChecked)
        .forEach((group) => {
          const { group_users: groupUsers, files } = getFileFromTable(tableData, { ...group, files: [] });
          groupUsers.forEach((user) => {
            const current = users[user.account];
            if (current) {
              users[user.account] = {
                ...user,
                files: fileDeduplication([...current.files, ...files]),
              };
            } else {
              users[user.account] = { ...user, files };
            }
          });
        });

      const result = Object.keys(users).map((key) => users[key]);
      const isNull = result.filter((item) => item.files.length);
      if (isEmpty(isNull)) return Promise.reject('No permission becomes notification required');
      dispatch.SetPermissionsAlertModel.setUsers(result);

      return result;
    },
    async sendAllAlert(payload) {
      const { userChangedFiles, subject, cc, content, signature } = payload;
      await dispatch.SetPermissionsModel.updateFilePermission();
      await Api.request(ApiConfig.postDocFileChangeMail, {
        subject,
        cc,
        content,
        user_changed_files: userChangedFiles,
        signature,
      });
    },
  }),
});

function fileDeduplication(files: UserType['files']) {
  const sets: { [key: string]: UserType['files'][0] } = {};
  files.forEach((file) => {
    const key = `${file.path}/${file.file_name}`;
    const set = sets[key];
    if (set) {
      sets[key] = file.level > set.level ? file : set;
    } else {
      sets[key] = file;
    }
  });
  return Object.keys(sets).map((key) => sets[key]);
}

function getFileFromTable(tableData: TableItetmType[], group: GroupType & { files: UserType['files'] }) {
  tableData.forEach((tableItem) => {
    const column = tableItem[group.id] as { action: string };
    if (column?.action && tableItem.type === 'file') {
      group.files.push({
        file_id: tableItem.id,
        file_name: tableItem.name,
        action: column.action,
        label: getPermissionLabel(column.action),
        level: getPermissionLevel(column.action),
        path: tableItem.path,
      });
    }
  });
  return group;
}

export default SetPermissionsAlertModel;
